// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse {
    static getAttributeTypeMap() {
        return PayloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse.attributeTypeMap;
    }
}
PayloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse.discriminator = undefined;
PayloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse.additionalProperties = false;
PayloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=payloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse.js.map